import { render, staticRenderFns } from "./addCollec.vue?vue&type=template&id=14a9196a&scoped=true"
import script from "./addCollec.vue?vue&type=script&lang=js"
export * from "./addCollec.vue?vue&type=script&lang=js"
import style0 from "./addCollec.vue?vue&type=style&index=0&id=14a9196a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9196a",
  null
  
)

export default component.exports